<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="(this.id?'编辑':'添加')+'成员'"
        :close-on-press-escape="false"
        width="800px"
        append-to-body
        :before-close="handleClose">
        <el-form ref="form" :rules="rules" :model="formItem" label-width="120px" class="pr40">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="成员：" prop="name" class="label-required">
                        {{formItem.name}}
                        <!--<el-input v-model.trim="formItem.name" ref="nameInput" maxlength="20" show-word-limit placeholder="请输入成员实际姓名" class="word-limit-input"></el-input>-->
                    </el-form-item>
                </el-col>
                <!--<el-col :span="12">-->
                    <!--<el-form-item label="部门：" prop="group_id" class="label-required">-->
                        <!--<TreeSelect-->
                            <!--:options="departmentData"-->
                            <!--v-model="formItem.group_id"-->
                            <!--:normalizer="normalizer"-->
                            <!--:defaultExpandLevel="3"-->
                            <!--placeholder="请选择归属部门"-->
                            <!--noResultsText="暂无数据"-->
                            <!--noOptionsText="暂无可用数据"-->
                            <!--class="font12px"-->
                        <!--/>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->
            </el-row>
            <!--<el-row>-->
                <!--<el-col :span="12">-->
                    <!--<el-form-item label="手机号：" prop="mobile" class="label-required">-->
                        <!--<el-input v-model.trim="formItem.mobile" placeholder="请输入成员实际手机号码"></el-input>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->
                <!--<el-col :span="12">-->
                    <!--<el-form-item label="邮箱：" prop="email" class="label-required">-->
                        <!--<el-input v-model.trim="formItem.email" placeholder="请输入成员实际公司邮箱"></el-input>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->
            <!--</el-row>-->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="角色：" prop="role_ids">
                        <ESelect v-model="formItem.role_ids" multiple filterable class="full-w role-select" placeholder="请选择角色">
                            <el-option
                                v-for="item in roleList"
                                :key="item.id"
                                :label="item.role_name"
                                :disabled="item.disabled"
                                :value="item.id">
                            </el-option>
                        </ESelect>
                    </el-form-item>
                </el-col>
            </el-row>
           <el-form-item>
             <p v-if="Array.isArray(ids)" style="color: red;font-size:12px">批量修改默认选中第一条信息展示修改，保存后将覆盖所有选中信息，请谨慎操作</p>
           </el-form-item>
            <!--<el-row>-->
                <!--<el-col :span="24">-->
                    <!--<el-form-item label="备注：" prop="note">-->
                        <!--<el-input-->
                            <!--type="textarea"-->
                            <!--:rows="2"-->
                            <!--placeholder="请输入内容"-->
                            <!--show-word-limit-->
                            <!--maxlength="50"-->
                            <!--resize="none"-->
                            <!--class="word-limit-input"-->
                            <!--v-model="formItem.note">-->
                        <!--</el-input>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->
            <!--</el-row>-->


        </el-form>

        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import TreeSelect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import API from '@/api/department.js';

    export default {
        name: "MemberModal",
        components:{
            TreeSelect,
        },
        props:{
            ids:{
                required:true,
                type:[Number,String, Array],
            },
            curGroup:[String,Number],
        },
        data() {
            let validateEmoji = (rule, value, callback)=>{
                let reg = /(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g;
                if(reg.test(value)){
                    callback(new Error('不可输入表情'));
                }else{
                    callback();
                }
            };
            return {
                submitLoading:false,
                dialogVisible: false,
                formItem: {
                    name: '',
                    mobile: '',
                    email: '',
                    role_ids: [],
                    note: '',
                    group_id:null,
                },
                rules:{
                    name: [
                        {required: true, message: '请输入成员名字', trigger: 'blur'},
                        {max: 20, message: '最多20个字', trigger: 'blur'},
                        { validator: validateEmoji, trigger: 'blur' },
                    ],
                    group_id: [
                        {required: true, message: '请选择归属部门', trigger: 'blur'},
                    ],
                    mobile:[
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        { type: 'string', pattern: /^1[0-9]{10}$/,message: '手机格式不正确', trigger: 'blur' }
                    ],
                    email:[
                        { required: true, message: '请输入邮箱', trigger: 'blur' },
                        { type: 'email', message: '邮箱格式不正确', trigger: 'blur' },
                        {max: 50, message: '邮箱最多50个字', trigger: 'blur'},
                        { validator: validateEmoji, trigger: 'blur' },
                    ],
                    role_ids: [
                        { type: 'array', required: true, message: '请选择成员角色', trigger: 'blur'},
                    ],
                    note:[
                        {max: 50, message: '最多50个字', trigger: 'blur'}
                    ]
                },
                roleList: [],
                departmentData: [],
                normalizer(node) {
                    return {
                        id: node.id,
                        label: node.name,
                        children: node.children,
                        isDisabled:node.disable,
                    }
                },
            }
        },
        computed: {
            id(){
                if(Array.isArray(this.ids) ){
                    return this.ids[0];
                }
                return this.ids;
            }
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            showModal() {
                this.dialogVisible = true;
                this.getDepartmentTree();
                this.$nextTick(()=>{
                    this.getRoleList();
                    if(this.id){
                        this.getUserInfo();
                    }else if(this.curGroup){
                        // this.formItem.group_id = this.curGroup;
                    }
                    // this.$refs.nameInput.focus();
                })
            },
            resetForm() {
                this.submitLoading = false;
                this.$refs['form'].resetFields();
            },
            getRoleList(){
                API.getRoleList({
                    user_id:this.id,
                }).then(res => {
                    this.roleList = res.data || [];
                }, (err) => {
                    console.log('getUserList error', err);
                    this.roleList = [];
                });
            },
            getDepartmentTree(){
                API.getTree().then(res => {
                    this.departmentData = [res.data];
                }, (err) => {
                    console.log('getDepartmentTree error', err);
                    this.departmentData = [];
                });
            },
            handleSubmit(){
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        if(this.id){
                            this.submitLoading = true;
                            API.editUser({
                                id:this.ids.toString(),
                                name:this.formItem.name,
                                group_id:this.formItem.group_id,
                                role_ids:this.formItem.role_ids,
                                mobile:this.formItem.mobile,
                                email:this.formItem.email,
                                note:this.formItem.note,
                            }).then(res => {
                                this.$message.success(res.info || '操作成功');
                                this.dialogVisible = false;
                                this.resetForm();
                                this.$emit('update');
                                this.submitLoading = false;
                            }, (err) => {
                                console.log('editUser error', err);
                                this.$message.error(err.info || '操作失败');
                                this.submitLoading = false;
                            });
                        }else{
                            this.submitLoading = true;
                            API.addUser({
                                name:this.formItem.name,
                                group_id:this.formItem.group_id,
                                role_ids:this.formItem.role_ids.join(','),
                                mobile:this.formItem.mobile,
                                email:this.formItem.email,
                                note:this.formItem.note,
                            }).then(res => {
                                this.$messageBox.confirm('保存成功，是否继续添加？', '提示', {
                                    closeOnPressEscape:false,
                                    confirmButtonText: '继续添加',
                                    cancelButtonText: '否',
                                    type: 'success'
                                }).then(() => {
                                    this.resetForm();
                                    this.$emit('update');
                                }).catch(() => {
                                    this.dialogVisible = false;
                                    this.resetForm();
                                    this.$emit('update');
                                });
                                this.submitLoading = false;
                            }, (err) => {
                                console.log('addRole error', err);
                                this.$message.error(err.info || '操作失败');
                                this.submitLoading = false;
                            });
                        }
                    } else {
                        return false;
                    }
                });
            },
            getUserInfo(){
                API.getUserInfo({
                    id: this.id,
                }).then(res => {
                    let resData = res.data||{};

                    this.formItem.name = resData.name;
                    this.formItem.mobile = resData.mobile;
                    this.formItem.email = resData.email;
                    this.formItem.role_ids = resData.role_ids?resData.role_ids.split(','):[];
                    this.formItem.note = resData.note;
                    this.formItem.group_id = resData.group_id;
                }, (err) => {
                    console.log('getUserInfo error', err);

                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        width: 120px;
    }

    ::v-deep .word-limit-input input,
    ::v-deep .word-limit-input textarea{
        padding-right: 44px;
    }

    ::v-deep .role-select .el-tag__close{
        display: none;
    }
</style>
